var _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFortumGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 113 113",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_82",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 82",
    x1: 48.41,
    y1: 7.19,
    x2: 63.93,
    y2: 83.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eef2f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#f6f8fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m36.45,97.66c-2.89-2.36-6.33-3.87-9.96-4.73-9.35-2.2-16.32-10.61-16.32-20.61V22C10.16,10.3,19.64.82,31.34.82h50.33c11.69,0,21.17,9.48,21.17,21.17v50.33c0,10.01-6.98,18.41-16.32,20.61-3.63.85-7.07,2.37-9.96,4.73l-16.09,13.11c-2.31,1.88-5.61,1.88-7.92,0l-16.09-13.11Z",
    fill: "#5ac37d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m31.51,10.2h50.15c6.51,0,11.8,5.29,11.8,11.8v50.33c0,6.51-5.29,11.8-11.8,11.8H31.34c-6.51,0-11.8-5.29-11.8-11.8V22.17c0-6.61,5.37-11.97,11.97-11.97Z",
    fill: "url(#_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_82)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m63.01,61.96c-9.29,0-16.65-7.27-16.66-16.42,0-9.43,7.47-17,16.76-16.99,9.26,0,16.68,7.37,16.67,16.53-.01,9.39-7.47,16.89-16.77,16.88Z",
    fill: "#5ac37d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m33.22,45.43c.42-10.71,4.8-19.23,13.87-25.19.5-.33.94-.37,1.5-.21,1.91.55,3.82,1.09,5.74,1.57.64.16.74.4.56,1.01-.58,2.03-1.1,4.07-1.63,6.11-.09.36-.27.59-.58.79-5.88,3.86-8.76,9.39-8.81,16.35-.06,9.28,6.87,17.03,16.09,18.18,3.89.49,7.57-.17,11.01-2.06.42-.23.61-.2.85.22,1.58,2.82,3.18,5.64,4.8,8.43.27.47.04.57-.29.75-5.07,2.8-10.48,4.05-16.27,3.56-6.75-.56-12.6-3.17-17.51-7.81-4.81-4.54-7.72-10.13-8.87-16.64-.3-1.67-.43-3.36-.47-5.07Z",
    fill: "#5ac37d"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 98,
    cy: 13,
    r: 10,
    fill: "#ddd"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 98,
    cy: 13,
    r: 7,
    fill: "#6dea00"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFortumGreen);
export default __webpack_public_path__ + "static/media/Fortum_green.23f9d5ec060724cf397513f4100227b0.svg";
export { ForwardRef as ReactComponent };